import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import Typography from '@/common/components/base/typography/Typography';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Center, Flex } from 'styled-system/jsx';
import { EDUCATION_LINKS } from '../../EducationLinks';
import { getCategoriesListQueryOptions } from '../../queries/getCategoriesList/getCategoriesListQueryOptions';

export default function CategoriesList() {
  const { data, isPending } = useQuery(getCategoriesListQueryOptions());
  const navigate = useNavigate();

  const handleCategoryClick = (category: { id: number; title: string }) => {
    const categoriesParam = JSON.stringify([
      { id: category.id, title: category.title },
    ]);

    navigate(
      `${EDUCATION_LINKS.educationList}?categories=${encodeURIComponent(
        categoriesParam,
      )}`,
    );
  };

  return (
    <Flex
      flexWrap="wrap"
      columnGap="16px"
      rowGap="24px"
      pb={6}
      justifyContent="center"
    >
      {isPending ? (
        <Center height="30vh">
          <CircularLoading color="colors.purple-primary" />
        </Center>
      ) : (
        data?.map((item) => (
          <Flex
            key={item?.id}
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            width="calc((100% - 32px) / 3)"
            gap={12}
            onClick={() => handleCategoryClick(item)}
          >
            <Flex
              width={50}
              height={50}
              alignItems="center"
              justifyContent="center"
              bg="purple-6"
              borderRadius="rounded"
            >
              <img src={item?.logo} alt="cate" />
            </Flex>

            <Typography color="black" textStyle="b2" textAlign="center">
              {item?.title}
            </Typography>
          </Flex>
        ))
      )}
    </Flex>
  );
}
